import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from "vue-router";
import { useAuthStore } from "@/auth/store";
import SimpleButton from "@/shared/components/SimpleButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutButton',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
async function logout() {
  await authStore.logout();
  await router.push({ name: "login" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleButton, {
    color: "danger",
    onClick: logout
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Logout ")
    ]),
    _: 1
  }))
}
}

})